import React from "react";
import { history } from "redux-first-router";

export default function TargetNumberDivision() {
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div class="container-fluid">
          <h6 class="font-weight-bolder mb-4">Add Source Masking Details.</h6>
          <div class="row">
            <div class="col-xl-8 col-sm-8 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i class="material-icons opacity-10">person</i>
                  </div>
                  <div class="text-end pt-1">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      Account Data Added, Please Provide Sender Masking Details
                      !! Field(s) marked with{" "}
                      <span class="text-danger fw-bold">*</span> are mandatory.
                    </p>
                  </div>
                </div>
                <div class="card-body scroll">
                  <form role="form" class="text-start mt-5">
                    {/* <!-------------------------group user details--------------------------> */}
                    <div class="card shadow-none border mb-5 bg_blue card_1">
                      <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                        Target Base
                      </span>
                      <div class="card-body text-lg-start text-center">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="form-check  form-check_1">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="customRadio1"
                              />
                              <label
                                class="custom-control-label"
                                for="customRadio1"
                              >
                                Own Numbers
                              </label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check form-check_1">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="customRadio1"
                              />
                              <label
                                class="custom-control-label"
                                for="customRadio1"
                              >
                                Targeted Numbers
                              </label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-check  form-check_1">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="customRadio1"
                              />
                              <label
                                class="custom-control-label"
                                for="customRadio1"
                              >
                                All Robi Numbers
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-none border mb-5 bg_blue card_1">
                      <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                        Geographical Targeting
                      </span>
                      <div class="card-body text-lg-start text-center">
                        <div class="row">
                          <div class="col-md-12 mb-4">
                            <div class="input-group input-group-outline pt-2">
                              <label
                                for="exampleFormControlSelect1"
                                class="ms-0 mb-0 d-inline-block"
                              >
                                Home Location
                                <span class="text-danger fw-bold">*</span>
                              </label>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Union
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Division
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  District/Thane
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Site Code
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">None</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="input-group input-group-outline pt-2">
                              <label
                                for="exampleFormControlSelect1"
                                class="ms-0 mb-0 d-inline-block"
                              >
                                Work Location
                                <span class="text-danger fw-bold">*</span>
                              </label>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Union
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Division
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  District/Thane
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">
                                  Site Code
                                </label>
                              </div>
                              <div class="form-check ps-0">
                                <input
                                  class="form-check-input ms-3"
                                  type="radio"
                                  name="adType"
                                />
                                <label class="custom-control-label">None</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                          <div class="col-md-12 mb-4">
                            <label
                              for="exampleFormControlSelect1"
                              class="ms-0 mb-0 d-inline-block pe-0 "
                            >
                              Union
                            </label>
                            <select
                              class="form-select select_7 ms-5 form-select_filter"
                              aria-label="Default select example"
                            >
                              <option selected>Open this select menu</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-none border mb-5 bg_blue card_1">
                      <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                        Demographic Targeting
                      </span>
                      <div class="card-body text-lg-start text-center">
                        <div class="row">
                          <div class="col-md-3">
                            <label class="form-label" for="customRange1">
                              Example range
                            </label>
                            <div class="range">
                              <input
                                type="range"
                                class="form-range"
                                id="customRange1"
                              />
                            </div>
                          </div>

                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Product Class</option>
                                <option>Prepaid</option>
                                <option>Postpaid</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Roaming Status</option>
                                <option>Off</option>
                                <option>On</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Financial Class</option>
                                <option>Ultra</option>
                                <option>High</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-none border mb-5 bg_blue card_1">
                      <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                        Behavioral Targeting
                      </span>
                      <div class="card-body text-lg-start text-center">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Activity Status</option>
                                <option>Active</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Voice Usage</option>
                                <option>Ultra</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="input-group input-group-outline mb-3">
                              <select
                                class="form-control form-select"
                                name="choices-button"
                                id="exampleFormControlSelect1"
                              >
                                <option>Data Usage</option>
                                <option>Ultra</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-sm-4 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i class="material-icons opacity-10">person</i>
                  </div>
                  <div class="text-end pt-1">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      Account Data Added, Please Provide Sender Masking Details
                      !! Field(s) marked with{" "}
                      <span class="text-danger fw-bold">*</span> are mandatory.
                    </p>
                  </div>
                </div>
                <div class="card-body scroll">
                  <div class="row">
                    <div class="col-md-6 mt-2">
                      <span>Total Cost</span>
                    </div>
                    <div class="col-md-6">
                      <span>show</span>
                      <select
                        class="form-select form-select_filter  width_3"
                        aria-label="Default select example"
                      >
                        <option selected></option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                      <span>entries</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
